module.exports = __webpack_public_path__ + "static/media/thumbsUpRef.a4163c2d.gif";